import { cn } from '@/lib/utils';

/**
 * One shape for every control in the app. A field that Bulk draws itself and a
 * field the browser draws have to sit on the same line and look like one thing,
 * so both read their geometry from here.
 */
export const CONTROL_SHELL = 'w-full min-w-0 rounded-[var(--radius-control)] border bg-white text-sm text-ink transition';
export const CONTROL_HEIGHT = 'h-10';
export const CONTROL_FOCUS = 'focus:border-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-200';
export const CONTROL_FOCUS_VISIBLE = 'focus-visible:border-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-200';
export const CONTROL_DISABLED = 'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400';

export function controlClass({ invalid, height = true, className }: { invalid?: boolean; height?: boolean; className?: string } = {}): string {
  return cn(CONTROL_SHELL, height && CONTROL_HEIGHT, CONTROL_FOCUS, CONTROL_DISABLED, invalid ? 'border-danger' : 'border-line hover:border-slate-300', className);
}

/** A floating surface: the same border as a card, lifted the way a dialog is. */
export const PANEL = 'z-50 rounded-[var(--radius-control)] border border-line bg-white shadow-lg shadow-slate-900/10';
export const PANEL_MOTION = 'data-[state=open]:animate-pop-in data-[state=closed]:animate-pop-out';

/** A row in a listbox, menu or calendar. */
export const OPTION_ROW = 'flex w-full cursor-pointer select-none items-center gap-2 rounded-[8px] px-2.5 py-2 text-left text-sm text-ink outline-none';
export const OPTION_ACTIVE = 'bg-slate-100';
export const OPTION_SELECTED = 'font-semibold text-ink';
export const OPTION_DISABLED = 'cursor-not-allowed text-slate-400';
